module.exports = __webpack_public_path__ + "media/images/bg-2-6d51be08b7129324b133f66f59108f32.jpg";